import { render } from "./Contact_en_m.vue?vue&type=template&id=6b89b470&scoped=true"
import script from "./Contact_en_m.vue?vue&type=script&lang=js"
export * from "./Contact_en_m.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6b89b470"

export default script